export function UiButton({ variant = 'primary', size = 'md', className = '', children, ...buttonProps }) {
  return (
    <button
      {...buttonProps}
      className={`ui-btn ui-btn--${variant} ui-btn--${size} ${className}`.trim()}
    >
      {children}
    </button>
  );
}
